/**
 * Created by fers on 26/10/16.
 */

/**
 * These functions are for converting viewTemplate (aka ScreenBoxToAdd) to real view
 */
import types from '../../../common/model-api/types';

// eslint-disable-next-line max-params
export function convertFromBoxesToView(boxToAdd, screen, dataSource, entityDef) {
    return ({
        view: {
            id: boxToAdd['id'],
            realId: boxToAdd['id'],
            handler: boxToAdd['handler'],
            name: boxToAdd['name'] ? boxToAdd['name'] : null,
            title: boxToAdd['title'] ? boxToAdd['title'] : null,
            screen_id: screen ? screen['id'] : null,
            screen: screen,
            dataSource: dataSource,
            dataSource_id: dataSource ? dataSource['realId'] : null,
            connectedChannel: boxToAdd ? boxToAdd['connectedChannel'] : null,
            connectedChannel_id: boxToAdd ? boxToAdd['connectedChannel_id'] : null,
            connectedChannelDef_id: boxToAdd ? boxToAdd['connectedChannelDef_id'] : null,
            entityViewDef: boxToAdd.entityViewDef,
            entityViewDef_id: boxToAdd.entityViewDef ? boxToAdd.entityViewDef['realId'] : null,
            backendOptions: boxToAdd.backendOptions,
            order: boxToAdd.order,
            filter: boxToAdd.filter,
            backendHandlers: boxToAdd.backendHandlers,
            channelAddon: boxToAdd.channelAddon,
            channelAddon_id: boxToAdd.channelAddon ? boxToAdd.channelAddon['realId'] : null,
            channelAddonChannel_id: boxToAdd.channelAddon ? boxToAdd.channelAddon['channel_id'] : null,
        },
        data: '[]',
        entityDef: entityDef,
		dataSource: dataSource,
        addon: '{}',
        screen_id: screen ? screen['id'] : null,
        screen: screen,
    });
}

export function convertViewForStore(screen, dataSource, viewTemplate) {
    let view = types['views'].defaultValues(screen);
    view['entityViewDef'] = viewTemplate.entityViewDef;
    view['entityViewDef_id'] = viewTemplate.entityViewDef_id;
    view['dataSource'] = dataSource;
    view['dataSource_id'] = dataSource ? dataSource['realId'] : null;
    view['backendHandlers'] = viewTemplate.backendHandlers;
    view['backendOptions'] = viewTemplate.backendOptions;
    view['order'] = viewTemplate.order;
    view['filter'] = viewTemplate.filter;
    view['handler'] = viewTemplate['handler'];
    view['channelAddon'] = viewTemplate.channelAddon;
    view['channelAddon_id'] = viewTemplate.channelAddon_id;
    view['channelAddonChannel_id'] = viewTemplate.channelAddonChannel_id;
    view['connectedChannel'] = viewTemplate.connectedChannel;
    view['connectedChannel_id'] = viewTemplate.connectedChannel_id;
    view['connectedChannelDef'] = viewTemplate.connectedChannelDef;
    view['connectedChannelDef_id'] = viewTemplate.connectedChannelDef_id;

    return view;
}
